import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aab8fda"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "page-header",
  role: "banner"
}
const _hoisted_2 = { class: "page-logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/logo.jpg",
  alt: "mediadept logo",
  "aria-roledescription": "logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-logo-text mr-1" }, "MEDIA DEPT 業務管理システム", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-absolute text-white opacity-50 small pos-top pos-right mr-2 mt-n2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden-md-down dropdown-icon-menu position-relative\" data-v-9aab8fda><a href=\"#\" class=\"header-btn btn js-waves-off\" data-action=\"toggle\" data-class=\"nav-function-hidden\" title=\"Hide Navigation\" data-v-9aab8fda><i class=\"ni ni-menu\" data-v-9aab8fda></i></a><ul data-v-9aab8fda><li data-v-9aab8fda><a href=\"#\" class=\"btn js-waves-off\" data-action=\"toggle\" data-class=\"nav-function-minify\" title=\"Minify Navigation\" data-v-9aab8fda><i class=\"ni ni-minify-nav\" data-v-9aab8fda></i></a></li><li data-v-9aab8fda><a href=\"#\" class=\"btn js-waves-off\" data-action=\"toggle\" data-class=\"nav-function-fixed\" title=\"Lock Navigation\" data-v-9aab8fda><i class=\"ni ni-lock-nav\" data-v-9aab8fda></i></a></li></ul></div><div class=\"hidden-lg-up\" data-v-9aab8fda><a href=\"#\" class=\"header-btn btn press-scale-down\" data-action=\"toggle\" data-class=\"mobile-nav-on\" data-v-9aab8fda><i class=\"ni ni-menu\" data-v-9aab8fda></i></a></div>", 2)
const _hoisted_8 = { class: "ml-auto d-flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-500" }, "ログアウトします。よろしいですか？", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/dashboard" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4,
        _hoisted_5
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light waves-effect waves-themed",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal4logout()))
          }, " ログアウト ")
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_logout" }, {
      title: _withCtx(() => [
        _hoisted_9,
        _hoisted_10
      ]),
      body: _withCtx(() => [
        _hoisted_11
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal4logout())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}